// project imports
import Loadable from 'components/Loadable';
import Tracker from 'components/Tracker';
import { lazy } from 'react';

// ==============================|| MAIN ROUTING ||============================== //
const LandingPage = Loadable(lazy(() => import('pages/LandingPage')));
const Home = Loadable(lazy(() => import('pages/Home')));
const Game = Loadable(lazy(() => import('pages/Game')));
const Draw = Loadable(lazy(() => import('pages/Draw')));

const MainRoutes = [
    {
        path: '/',
        element: (
            <Tracker ga="landing_page">
                <LandingPage />
            </Tracker>
        )
    },
    {
        path: '/home',
        element: (
            <Tracker ga="home_page">
                <Home />
            </Tracker>
        )
    },
    {
        path: '/game/:level',
        element: (
            <Tracker ga="game_page">
                <Game />
            </Tracker>
        )
    },
    {
        path: '/draw',
        element: (
            <Tracker ga="draw_page">
                <Draw />
            </Tracker>
        )
    }
];

export default MainRoutes;
